import axiosInstance from '../../config/axiosInstance';
import { PublicSettings } from '../../types/settings';

class SettingsService {
  private readonly BASE = '/settings';

  async getPublic(): Promise<PublicSettings> {
    return axiosInstance.get(`${this.BASE}/public`);
  }
}

export const settingsService = new SettingsService();
